/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file

==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";

// Vuesax Component Framework
import Vuesax from "vuesax";
import(/* webpackPreload: true */ "material-icons/iconfont/material-icons.css"); //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax

import helpers from "./utils/helpers";
import constant from "./utils/constant";
import highlight from "./utils/highlight";

Vue.use(Vuesax);

// axios
import axios from "./utils/axios.js";
Vue.prototype.$http = axios;

// API Calls
import "./http/requests";

// Theme Configurations
import "../themeConfig.js";

// ACL
import acl from "./acl/acl";

// Globally Registered Components
import "./globalComponents.js";

// Feather font icon
import "./assets/css/iconfont.css";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n.js";

// Vuexy Admin Filters
import "./filters/filters";

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// import ElementUI from "element-ui";
// import locale from "element-ui/lib/locale/lang/en";

// Vue.use(ElementUI, { locale });

Vue.use({
	install() {
		Vue.helper = helpers;
		Vue.constant = constant;
		Vue.highlight = highlight;
		Vue.prototype.$helper = helpers;
		Vue.prototype.$constant = constant;
		Vue.prototype.$highlight = highlight;
	}
});

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

Vue.config.productionTip = false;

import { Validator } from "vee-validate";

import vi from "vee-validate/dist/locale/vi.js";
const customViDict = {
	en: {
		messages: {
			isSmaller: (field, crossFieldData) => {
				if (typeof crossFieldData.value !== "number") {
					return `${crossFieldData.name} is invalid`;
				}
				return `The value of ${field} must be smaller than ${crossFieldData.name}`;
			}
		}
	},
	vi: {
		messages: {
			isSmaller: (field, crossFieldData) => {
				if (typeof crossFieldData.value !== "number") {
					return `Giá trị ${crossFieldData.name} không hợp lệ`;
				}
				return `Giá trị ${field} phải nhỏ hơn ${crossFieldData.name}`;
			},
			integer: field => {
				return `Giá trị ${field} phải là kiểu số nguyên`;
			}
		}
	}
};

// Install and Activate the viabic locale.
Validator.localize("vi", vi);
Validator.localize(customViDict);
Validator.localize(process.env.VUE_APP_I18N_LOCALE || "en");
Validator.extend("isSmaller", {
	validate: function(value, crossFieldData) {
		return value < crossFieldData.value;
	}
});

import {
	Dialog,
	Input,
	Upload,
	DatePicker,
	TimePicker,
	Progress,
	Collapse,
	CollapseItem,
	Select,
	Tag,
	Option
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Upload);
Vue.use(Select);
Vue.use(Option);
Vue.use(Progress);
Vue.use(Collapse);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(CollapseItem);
Vue.use(Tag);

// Perfect scrollbar
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
Vue.use(PerfectScrollbar);

// Mixins
import mixins from "@/mixins/mixins";
Vue.mixin(mixins);

// Socket
// import VueSocketIO from "vue-socket.io";

// if (process.env.VUE_APP_SOCKET_URL) {
// 	Vue.use(
// 		new VueSocketIO({
// 			// debug: true,
// 			connection: process.env.VUE_APP_SOCKET_URL,
// 			options: { path: "/cma-socket" }
// 		})
// 	);
// }

// Sentry config
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: process.env.VUE_APP_SENTRY_DSN,
		environment: process.env.VUE_APP_ENV,
		integrations: [new VueIntegration({ Vue, attachProps: true })]
	});
}

new Vue({
	router,
	store,
	i18n,
	acl,
	// sockets: {
	// 	connect: function() {
	// 		if (
	// 			this.$store.state.AppActiveUser &&
	// 			this.$store.state.AppActiveUser.role
	// 		) {
	// 			const { cluster_id, role } = this.$store.state.AppActiveUser;
	// 			cluster_id && this.$socket.emit("my-cluster-is", cluster_id);
	// 			role.id && this.$socket.emit("my-id-is", role.id);
	// 		}
	// 	}
	// },

	render: h => h(App)
}).$mount("#app");
